<script>
import paleta from '@/functions/color/paleta.js';

export default {
    props: ['title', 'datacontent'],
    data() {
        return {
            count: 0,
            colorList: [],
            legendOpacity: 1,
            legendRectSize: 13,
            legendSpacing: 6,
        };
    },
    methods: {
        getColor(index, alfa) {
            let cor = null;
            if (index != null) {
                while (index >= paleta.chartColors.length) {
                    index = index - paleta.chartColors.length;
                }
                cor = paleta.chartColors[index];
            } else {
                cor = paleta.chartColors[this.count++];
                if (this.count == paleta.chartColors.length) {
                    this.count = 0;
                }
            }
            this.colorList.push(cor);
            if (alfa) {
                cor = this.getAlfa(cor, alfa);
            }
            return cor;
        },
        getAlfa(cor, alfa) {
            let a = (255 * alfa) / 100;
            return cor + Math.round(a).toString(16);
        },
        replaceDot(v) {
            return (Math.round(v * 100) / 100 + '').replace('/./g', this.$t('scale-separator'));
        },
        getCurrencyValue(value) {
            const prefix = this.$t('prefix');
            const separator = this.$t('separator');
            const scaleSeparator = this.$t('scale-separator');
            const decimalScale = Number(this.$t('decimal-scale'));

            let vs = value + '';
            let integer = vs.split('.')[0];
            let decimal = vs.split('.')[1] || '';
            let rv = integer.split('').reverse().join('');
            let fv = rv
                .match(/.{1,3}/g)
                .join()
                .split('')
                .reverse()
                .join('')
                .replace(/,/g, separator);

            let fd = '';
            while (decimal.length < decimalScale) {
                decimal += '0';
            }

            for (let i = 0; i <= decimalScale; i++) {
                if (i < decimalScale) {
                    fd += decimal.charAt(i);
                } else {
                    let temp = decimal.charAt(i);
                    if (temp) {
                        fd = temp > 4 ? Number(fd) + 1 + '' : fd;
                    }
                }
            }

            return `${prefix} ${fv}${scaleSeparator}${fd}`;
        },
        addClass(d, i) {
            if (!d.active) {
                return 'deactivate';
            }
            return '';
        },
        getNextIntegerNumber(v) {
            let iv = Math.floor(v);
            let vs = iv + '';
            let t = vs.length;
            let fn = Number(vs.substring(0, 1));
            let adder = fn > 3 ? 10 ** (t - 1) : 10 ** (t - 2);
            let nv = fn * 10 ** (t - 1) + adder;

            while (nv < v) {
                nv += adder;
            }
            return nv;
        },
        getXRange(xAxis, width) {
            let gap = xAxis.length - 1;
            let mrange = width / (gap == 0 ? 1 : gap);
            return xAxis.map((xa, i) => i * mrange);
        },
        numberFormatter(number) {
            let formatter = new Intl.NumberFormat();
            let p = formatter.formatToParts(number);

            let g = p.filter((e) => {
                return e.type == 'group';
            });

            if (g.length < 1) {
                return formatter.format(number);
            } else {
                let sufix = '';
                let value = '';

                if (p[0].value.length == 3) {
                    value = p[0].value;
                } else {
                    value = `${p[0].value}${
                        p[0].value.length < 2 ? this.$t('scale-separator') : ''
                    }${p[2].value.substring(0, 2 - p[0].value.length)}`;
                }

                switch (g.length) {
                    case 1:
                        sufix = 'k';
                        break;
                    case 2:
                        sufix = 'M';
                        break;
                    case 3:
                        sufix = 'B';
                        break;
                    case 4:
                        sufix = 'T';
                        break;
                }

                return `${value}${sufix}`;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
// @import "../../../styles.scss";

.big-number .cockpit-chart {
    overflow-y: hidden;
    overflow-x: auto;
}

.cockpit-chart {
    background: $sovis-white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    height: 100%;
    .chart-title {
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        font-size: 12px;
        color: $text-color;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 10px;
        border-bottom: 0.5px solid $table-border;
        height: 40px;
        width: 100%;
    }
    .chart-content {
        height: 290px;
        &.speedometer {
            text-align: center;
            height: 200px;
            margin-top: 50px;
            margin-bottom: 30px;
        }
        &.big-number-content {
            height: 80px;
        }
        &.long-text-content {
            height: auto;
            min-height: 80px;
            max-height: 300px;
        }
        svg {
            height: 100%;
            width: 100%;
        }

        &.group-bar-chart {
            overflow-x: auto;
            overflow-y: hidden;

            svg {
                height: auto;
                width: auto;
            }
        }

        .big-number-wrapper {
            text-align: center;

            > .big-number {
                margin: auto;
                margin-top: 17px;
                width: auto;
                display: inline-block;
                > .big-number-um {
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                    font-size: 14px;
                    color: $primary-color-hover;
                    text-align: right;
                }
                > .big-number-value {
                    font-style: normal;
                    font-weight: bold;
                    line-height: normal;
                    font-size: 62px;
                    text-align: center;
                    color: $bn-color;
                }
                > .big-number-currency {
                    height: 80px;
                    margin-top: 20px;
                    font-style: normal;
                    font-weight: bold;
                    line-height: normal;
                    text-align: center;
                    color: $bn-color;
                }
            }
        }
        rect.disabled {
            fill: transparent !important;
        }
    }
    .chart-footer {
        height: auto;
        min-height: 45px;
        text-align: center;
        padding: 5px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;

        &.bn {
            justify-content: flex-start;
        }

        .legend {
            display: inline-flex;
            width: auto;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            font-size: 9px;
            color: $sovis-black;
            margin-right: 7px;
            margin-top: 7px;
            text-transform: uppercase;

            &.deactive {
                opacity: 0.4;
            }
            .legend-color-box,
            span {
                min-width: 13px;
                height: 13px;
                display: inline-block;
                margin-right: 5px;
            }
        }

        .legend-chart {
            display: flex;
            overflow-x: auto;
            width: 100%;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            font-size: 9px;
            color: $sovis-black;
            margin-right: 7px;
            margin-left: 7px;
            // margin-top: 7px;
            align-items: center;
            text-transform: uppercase;
            // justify-content: space-around;

            &.deactive {
                opacity: 0.4;
            }

            /* Para centralizar quando não há overflow */
            &::before,
            &::after {
                content: '';
                margin: auto;
            }
        }

        .big-number-result,
        .big-number-extra-result {
            text-align: right;
            padding-right: 8px;
            font-style: normal;
            font-weight: bold;
            line-height: normal;
            font-size: 14px;
            margin-top: 24px;
            width: 50%;
        }

        .big-number-extra-result {
            text-align: left;
            padding-left: 8px;
            padding-right: 0;
            color: $text-color;
        }
    }
    .long-text-content {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .long-text-wrapper {
            border: 1px solid $darker-gray-color;
            background: $light-gray-color;
            border-radius: 6px;
            width: 31%;
            margin-right: 1%;
            margin-top: 10px;
            margin-left: 1%;

            :last-child {
                margin-right: 0;
            }
        }
    }

    .no-data {
        width: 100%;
        height: calc(100% - 40px);
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;

        &.bar {
            height: 330px;
        }

        div {
            width: 100%;
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            color: $text-color;
            margin-top: 10px;
        }

        svg.fail {
            fill: $text-color;
            width: 50px !important;
            height: 50px !important;
        }

        svg.loading {
            fill: $text-color;
            width: 50px !important;
            height: 50px !important;
            animation-name: spin;
            animation-duration: 2000ms;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
    }

    .chart-no-text {
        width: 100%;
        height: 330px;
        position: relative;
        text-align: center;

        div {
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            font-size: 12px;
            color: $text-color;
        }
        svg {
            width: 50%;
            height: 50%;
            margin-top: 10%;
            margin-bottom: 15px;
            fill: $text-color;
        }
    }
}
</style>
